import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector(".procedures-slider");

    if (slider) {
        var splide = new Splide(slider, {
            type: "slider",
            rewind: true,
            speed: 1000,
            pagination: false,
            perPage: 2.5,
            perMove: 1,
            arrows: true,
            breakpoints: {
                960: {
                    perPage: 2
                },
                720: {
                    perPage: 1
                }
            },
        });

        splide.mount();
    }
});